var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var commonButtonsStyles = function (circular) { return (__assign({}, (!circular && {
    margin: '0px',
    borderRadius: '0px',
}))); };
var buttonGroupStyles = {
    root: function () { return ({}); },
    middleButton: function (_a) {
        var p = _a.props;
        return (__assign({}, commonButtonsStyles(p.circular)));
    },
    firstButton: function (_a) {
        var p = _a.props, v = _a.variables;
        return (__assign({}, commonButtonsStyles(p.circular), (!p.circular && {
            borderTopLeftRadius: v.borderRadius,
            borderBottomLeftRadius: v.borderRadius,
        })));
    },
    lastButton: function (_a) {
        var p = _a.props, v = _a.variables;
        return (__assign({}, commonButtonsStyles(p.circular), (!p.circular && {
            borderTopRightRadius: v.borderRadius,
            borderBottomRightRadius: v.borderRadius,
        })));
    },
};
export default buttonGroupStyles;
